import { signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export class DominiosSharedDataService {

  private updateList = new Subject<boolean>();
  updateList$ = this.updateList.asObservable();

  private dominioSelecionado = new BehaviorSubject<any>(null);
  dominioSelecionado$ = this.dominioSelecionado.asObservable();

  private adicionarDominioPrincipal = new BehaviorSubject<boolean>(false);
  adicionarDominioPrincipal$ = this.adicionarDominioPrincipal.asObservable();

  constructor() { }

  public setUpdateList(data: boolean): void {
    this.updateList.next(data);
  }

  public setDominioSelecionado(data: any): void {
    this.dominioSelecionado.next(data);
  }

  public setAdicionarDominioPrincipal(data: boolean): void {
    this.adicionarDominioPrincipal.next(data);
  }
}
